<template>
  <b-modal :active="value" has-modal-card @close="close()">
    <form action="">
      <div class="modal-card" style="width: 100%; min-width: 300px">
        <header class="modal-card-head">
          <p
            class="modal-card-title"
            style="color: whitesmoke; text-align: left"
          >
            緊急連絡レベル選択
          </p>
        </header>

        <section class="modal-card-body" style="min-height: 282px">
          <single-select-list
            v-model="emergencyLevel"
            :items="emergencyLevelItems"
            :native-size="6"
          />
        </section>

        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            :disabled="!emergencyLevel"
            @click="enter()"
          >
            決定
          </button>
          <button class="button" type="button" @click="close()">閉じる</button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
import SingleSelectList from "./SingleSelectList";
import { EMERGENCY_CONTACT_LEVELS } from "../../utils/patient";

export default {
  name: "EmergencyLevelChooser",

  components: {
    "single-select-list": SingleSelectList,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    let emergencyLevelMaster = JSON.parse(JSON.stringify(EMERGENCY_CONTACT_LEVELS));
    emergencyLevelMaster = [{code: "", name: ""}, ...emergencyLevelMaster];
    return {
      emergencyLevel: null,
      emergencyLevelItems: emergencyLevelMaster,
    };
  },

  methods: {
    enter: function () {
      this.$emit("selected", this.emergencyLevel);
      this.close();
      return;
    },

    close: function () {
      this.$emit("input", false);
      return;
    },
  },

  watch: {
    value: function (newValue) {
      if (newValue) {
        this.emergencyLevel = null;
      }
      return;
    },
  },

  filters: {},
};
</script>



// WEBPACK FOOTER //
// src/components/common/EmergencyLevelChooser.vue